import "@zillow/constellation";
import "styled-components";
const widthMap = {
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  full: "1920px"
};
const GROUP_WIDTH_MAP = widthMap;
export {
  GROUP_WIDTH_MAP
};
